import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getBudgetPeriodDates, setDateHelper } from '../../utils/Helper';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import Button from '../../components/ui/Button';
import CustomReactSelect from '../../components/ui/CustomReactSelect';

const months = [
    { label: "January", value: 0 },
    { label: "February", value: 1 },
    { label: "March", value: 2 },
    { label: "April", value: 3 },
    { label: "May", value: 4 },
    { label: "June", value: 5 },
    { label: "July", value: 6 },
    { label: "August", value: 7 },
    { label: "September", value: 8 },
    { label: "October", value: 9 },
    { label: "November", value: 10 },
    { label: "December", value: 11 },
];

const SelectMonthAndYearModalForOppertunityCost = ({ billingDate, refetchData, onContinue, selectMonth }: any) => {

    const oppertunityCost = useMakeRequest();
    const currentYear = moment().year();
    const currentMonth = moment().month();
    const years = Array.from({ length: 21 }, (_, i) => ({
        label: currentYear + i,
        value: currentYear + i,
    }));
    let currentMonthObj = months.find(month => month.value === currentMonth)
    const [selectedYear, setSelectedYear]: any = useState(years[0]);
    const [selectedMonth, setSelectedMonth]: any = useState(currentMonthObj);
    const [errorMessage, setErrorMessage] = useState<string | null>(null)

    useEffect(() => {
        if (refetchData) {
            handleContinue();
        }
    }, [refetchData]);

    const handleContinue = () => {
        if (!selectedYear) {
            setErrorMessage('Please select year.')
        } else if (selectedMonth === null) {
            setErrorMessage('Please select month.')
        } else {
            setErrorMessage(null)
            const { startDate, endDate } = getBudgetPeriodDates(
                selectedYear.value,
                selectedMonth?.value,
                billingDate
            );

            oppertunityCost.makeRequest({
                url: ApiConstants?.OppertunityCostCheck,
                payload: {
                    month: months[selectedMonth?.value]?.value,
                    start_date: startDate,
                    end_date: endDate,
                },
            })
        }
    };

    useEffect(() => {
        if (oppertunityCost?.status) {
            console.log("oppertunityCost?.data", oppertunityCost?.data)

            selectMonth(months[oppertunityCost?.data?.data?.total?.month]?.label)
            onContinue({
                start_date: oppertunityCost?.data?.data?.total?.start_date,
                end_date: oppertunityCost?.data?.data?.total?.end_date,
                month: oppertunityCost?.data?.data?.total?.month,
                total_completed_hours: oppertunityCost?.data?.data?.total?.total_completed_hours || 0,
                prevRate: oppertunityCost?.data?.data?.total?.previousClaimedRate || 0,
                prevHours: oppertunityCost?.data?.data?.total?.previousUserEnteredHours || 0,
                prevDesc: oppertunityCost?.data?.data?.total?.previousDescription || "",
                average: oppertunityCost?.data?.data?.total?.average || 0,
                members: oppertunityCost?.data?.data?.members || [],
                is_finalized: oppertunityCost?.data?.data?.total?.is_finalized,
                prevClaimedUsers: oppertunityCost?.data?.data?.total?.previousClaimsDetails
            })

            const modal: any = $('#selectDateModalOppertunityCost');
            modal.modal('hide')
            $('.modal-backdrop').remove();
        }
        // handleContinue()
    }, [oppertunityCost?.status])

    return (
        <div className="modal fade bottom-sheet-modal bottom-sheet-select-modal" id="selectDateModalOppertunityCost" tabIndex={-1} aria-labelledby="selectDateModalOppertunityCostLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog">
                <div className="modal-content">
                    {/* Bottom Sheet Handle */}
                    <div className="bottom-sheet-handle">
                        <div className="handle-bar"></div>
                    </div>

                    <div className="modal-header">
                        <h1 className="modal-title" id="selectDateModalOppertunityCost">Select Budget Period</h1>
                    </div>
                    <div className="page-padding-x" style={{ paddingBottom: '32px' }}>

                        <CustomReactSelect
                            label="Select Year"
                            value={selectedYear}
                            options={years}
                            className="com-r-select"
                            classNamePrefix="com-r-select"
                            placeholder="Select Year"
                            onChange={(option) => setSelectedYear(option)}
                            closeMenuOnScroll={true}
                            closeMenuOnSelect={true}
                        />

                        <div style={{ marginBottom: '24px' }} />

                        <CustomReactSelect
                            label="Select Month"
                            value={selectedMonth}
                            options={months}
                            className="com-r-select"
                            classNamePrefix="com-r-select"
                            placeholder="Select Month"
                            onChange={(option) => setSelectedMonth(option)}
                            closeMenuOnScroll={true}
                            closeMenuOnSelect={true}
                        />

                        {errorMessage ? <p className='text-error' style={{ marginTop: '16px', marginBottom: '16px' }}>{errorMessage}</p> : ''}

                        <Button className='com-btn mt-5' style={{ width: "100%" }} onClick={handleContinue} loading={oppertunityCost?.loading}>Continue</Button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectMonthAndYearModalForOppertunityCost;

// import moment from 'moment';
// import React, { useEffect, useState } from 'react';
// import Select from 'react-select';
// import { setDateHelper } from '../../utils/Helper';
// import useMakeRequest from '../../utils/ApiHelper';
// import { ApiConstants } from '../../constants/ApiConstants';
// import Button from '../../components/ui/Button';

// const months = [
//     { label: "January", value: 0 },
//     { label: "February", value: 1 },
//     { label: "March", value: 2 },
//     { label: "April", value: 3 },
//     { label: "May", value: 4 },
//     { label: "June", value: 5 },
//     { label: "July", value: 6 },
//     { label: "August", value: 7 },
//     { label: "September", value: 8 },
//     { label: "October", value: 9 },
//     { label: "November", value: 10 },
//     { label: "December", value: 11 },
// ];

// const SelectMonthAndYearModalForOppertunityCost = ({ billingDate, refetchData, onContinue, selectMonth }: any) => {

//     const oppertunityCost = useMakeRequest();
//     const currentYear = moment().year();
//     const currentMonth = moment().month();
//     const years = Array.from({ length: 21 }, (_, i) => ({
//         label: currentYear + i,
//         value: currentYear + i,
//     }));

//     const [selectedYear, setSelectedYear]: any = useState(years[0]);
//     const [selectedMonth, setSelectedMonth]: any = useState(currentMonth);
//     const [errorMessage, setErrorMessage] = useState<string | null>(null)

//     useEffect(() => {
//         if (refetchData) {
//             handleContinue();
//         }
//     }, [refetchData]);

//     const handleContinue = () => {
//         if (!selectedYear) {
//             setErrorMessage('Please select year.')
//         } else if (selectedMonth === null) {
//             setErrorMessage('Please select month.')
//         } else {
//             setErrorMessage(null)
//             const startDate = setDateHelper({ date: moment({ year: selectedYear.value, month: selectedMonth, day: billingDate }) });
//             const endDate = moment(startDate).add(1, 'month').subtract(1, 'day');

//             oppertunityCost.makeRequest({
//                 url: ApiConstants?.OppertunityCostCheck,
//                 payload: {
//                     month: months[selectedMonth]?.value,
//                     start_date: startDate,
//                     end_date: setDateHelper({ date: endDate }),
//                 },
//             })
//         }
//     };

//     useEffect(() => {
//         if (oppertunityCost?.status) {
//             console.log("oppertunityCost?.data", oppertunityCost?.data)

//             selectMonth(months[oppertunityCost?.data?.data?.total?.month]?.label)
//             onContinue({
//                 start_date: oppertunityCost?.data?.data?.total?.start_date,
//                 end_date: oppertunityCost?.data?.data?.total?.end_date,
//                 month: oppertunityCost?.data?.data?.total?.month,
//                 total_completed_hours: oppertunityCost?.data?.data?.total?.total_completed_hours || 0,
//                 prevRate: oppertunityCost?.data?.data?.total?.previousClaimedRate || 0,
//                 prevHours: oppertunityCost?.data?.data?.total?.previousClaimedHours || 0,
//                 prevDesc: oppertunityCost?.data?.data?.total?.previousDescription || "",
//                 average: oppertunityCost?.data?.data?.total?.average || 0,
//                 members: oppertunityCost?.data?.data?.members || [],
//                 is_finalized: oppertunityCost?.data?.data?.total?.is_finalized,
//                 prevClaimedUsers: oppertunityCost?.data?.data?.total?.previousClaimsDetails
//             })

//             const modal: any = $('#selectDateModalOppertunityCost');
//             modal.modal('hide')
//             $('.modal-backdrop').remove();
//         }
//         // handleContinue()
//     }, [oppertunityCost?.status])

//     return (
//         <div className="modal fade inner-modal com-modal date-month-modal" id="selectDateModalOppertunityCost" tabIndex={-1} aria-labelledby="selectDateModalOppertunityCostLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
//             <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
//                 <div className="modal-content">
//                     {/* <div className="modal-header">
//                         <h1 className="modal-title" id="selectDateModalOppertunityCostLabel">Select Year & Month</h1>
//                         <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className='icon-close-circle'></i></button>
//                     </div> */}
//                     <div className="modal-body">
//                         <div className="com-input-grp">
//                             <label className="form-label">Select Year</label>
//                             <div className='custom-select'>
//                                 <Select
//                                     className="com-r-select"
//                                     classNamePrefix="com-r-select"
//                                     placeholder="Select Year"
//                                     options={years}
//                                     onChange={(option) => setSelectedYear(option)}
//                                     value={selectedYear}
//                                 />
//                             </div>
//                         </div>
//                         <div className="com-input-grp mt-4">
//                             <label className="form-label">Select Month</label>
//                             <div className='month-grid'>
//                                 {months.map((month) => (
//                                     <div className='single-month' key={month.value}>
//                                         <input
//                                             type="radio"
//                                             id={`${month.label}Month`}
//                                             name='month'
//                                             checked={selectedMonth === month.value}
//                                             onChange={() => setSelectedMonth(month.value)}
//                                         />
//                                         <label htmlFor={`${month.label}Month`}>{month.label}</label>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                         {errorMessage ? <p className='text-error'>{errorMessage}</p> : ''}
//                     </div>
//                     <div className='modal-footer border-0 mt-4'>
//                         <Button className='com-btn me-auto' style={{ width: "100%" }} onClick={handleContinue} loading={oppertunityCost?.loading}>Continue</Button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SelectMonthAndYearModalForOppertunityCost;
